<button [attr.aria-label]="label()" [attr.title]="label()">
  <app-icon [src]="icon()" [size]="size()" />
</button>
